// ** Initial State
const initialState = {
  data: [],
  total: 1,
  params: {},
  allData: [],
  notifyDelete: null,
  notifyFailedDelete: null
}

const DataTablesReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_DATA_AREA':
      return {
        ...state,
        allData: action.allData,        
        data: action.data,
        total: action.totalPages,
        params: action.params
      }   
    default:
      return state
  }
}

export default DataTablesReducer
